<template>
  <button
    @click="$emit('click')"
    :class="buttonColor"
    class="flex items-center justify-between rounded focus:outline-none transition-colors duration-150 text-sm py-2 px-3 poppins"
    type="button"
  >
  <slot></slot>
  </button>
</template>

<script>
export default {
  data: () => {
    return {
      buttonColor: "",
    };
  },
  mounted() {
    if (this.buttonClass == "primary") {
      this.buttonColor =
        "bg-blue-500 hover:bg-blue-700 focus:bg-blue-700 text-white";
    } else if (this.buttonClass == "secondary") {
      this.buttonColor =
        "bg-teal-500 hover:bg-teal-600 focus:bg-teal-600 text-white";
    } else if (this.buttonClass == "default") {
      this.buttonColor =
        "bg-gray-400 hover:bg-gray-800 hover:text-white focus:bg-gray-800 focus:text-white";
    } else if (this.buttonClass == 'danger') {
      this.buttonColor = "bg-red-500 hover:bg-red-700 focus:bg-red-700 text-white"
    }
  },
  props: {
    buttonClass: {
      type: String,
      default: "primary",
    },
  },
};
</script>
